import { SimpleLockIcon } from '@/utils/helpers/icons.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Notice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--small-padding); /* Figma: 10px -> rounded up to 12px */
  width: 314px; /* No matching token - Figma: 314px */
  flex-shrink: 0;
  padding: var(--medium-big-padding);
  background-color: var(--white-main);
  border: 1px solid var(--gray-dark);
  border-radius: var(--xsmall-border-radius);
`;

const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--xxsmall-padding);
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  svg {
    height: 18px;
    width: auto;

    path {
      fill: var(--black-main);
    }
  }
`;

const Title = styled.span`
  font-size: var(--medium-font-size);
  font-weight: var(--semibold-font-weight);
  line-height: var(--default-line-height);
`;

const Body = styled.p`
  margin: 0;
  font-size: var(--small-font-size);
  font-weight: var(--regular-font-weight);
  line-height: var(--default-line-height);
`;

export const ViewOnlyNotice: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Notice className={className}>
      <TitleRow>
        <IconWrapper>
          <SimpleLockIcon />
        </IconWrapper>
        <Title>{t('permissions.viewOnly.title')}</Title>
      </TitleRow>
      <Body>{t('permissions.viewOnly.body')}</Body>
    </Notice>
  );
};
